import _ from "lodash";
import { createSelector } from "reselect";

const usersKey = "visitorPermitReducer";

export const getVisitorPermitListState = (state) => _.get(state, usersKey);

export const getVisitorPermitListReducer = createSelector(
  getVisitorPermitListState,
  (state) => _.get(state, "visitorPermitListState")
);

export const getVisitorPermitCardType = createSelector(
  getVisitorPermitListState,
  (state) => _.get(state, "visitorPermitCardType")
);
